var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { createContext, useContext } from 'react';
var DialogContext = createContext(undefined);
function DialogProvider(_a) {
    var children = _a.children, value = __rest(_a, ["children"]);
    return (_jsx(DialogContext.Provider, __assign({ value: value }, { children: children })));
}
var useHasParentDialog = function () { return useContext(DialogContext) != null; };
function useDialog() {
    var context = useContext(DialogContext);
    if (context === undefined) {
        throw new Error('Make sure to wrap useDialog with a DialogProvider or Dialog component.');
    }
    return context;
}
export { DialogProvider, useDialog, useHasParentDialog };
